import AttorneyHubAPIService from "_shared/_api/attorney-hub-api-service";
import PaginatedResponse from "_shared/_api/pagination/responses/paginated-response";
import Guid from "_shared/guids/guid";
import axios, { AxiosHeaders, CanceledError } from "axios";
import Session from "users/__session/session";
import { FeeScheduleTemplateJSON } from "work/fee-schedule-templates/_schemas/fee-schedule-template-schema";
import FeeScheduleTemplateQuery from "./contracts/fee-schedule-template-query";

export default class FeeScheduleTemplateQueryAPIService {
  public constructor(session: Readonly<Session>) {
    if (!session.authToken?.value)
      throw new Error("Session must have an authToken to create a FeeScheduleTemplateAPIService");
    this.authHeaders.set("Authorization", `Bearer ${session.authToken.value}`);
  }

  public async getFeeScheduleTemplatesByQuery(
    query: FeeScheduleTemplateQuery,
    abortController?: AbortController
  ): Promise<PaginatedResponse<FeeScheduleTemplateJSON>> {
    const paramsString = query.searchParams.toString();
    const url = new URL(
      `/work/fee-schedule-templates?${paramsString}`,
      AttorneyHubAPIService.apiBaseUrl
    );
    try {
      const response = await axios.get(url.toString(), {
        headers: this.authHeaders,
        signal: abortController?.signal,
      });

      return PaginatedResponse.from<FeeScheduleTemplateJSON>(response.data, response.headers["x-pagination"]);
    } catch (error) {
      if (error instanceof CanceledError) throw error;
      throw new FeeScheduleTemplateAPIServiceError("getFeeScheduleTemplates", error);
    }
  }

  public async getFeeScheduleTemplateById(
    id: Guid,
    abortController?: AbortController
  ): Promise<FeeScheduleTemplateJSON> {
    const url = new URL(`/work/fee-schedule-templates/${id.value}`, AttorneyHubAPIService.apiBaseUrl);
    try {
      const response = await axios.get(url.toString(), {
        headers: this.authHeaders,
        signal: abortController?.signal,
      });
      return response.data;
    } catch (error) {
      if (error instanceof CanceledError) throw error;
      throw new FeeScheduleTemplateAPIServiceError("getFeeScheduleTemplateById", error);
    }
  }

  private readonly authHeaders: AxiosHeaders = new AxiosHeaders();
}

export class FeeScheduleTemplateAPIServiceError extends Error {
  public method: string;
  public error: unknown;
  constructor(method: string, error: unknown) {
    super(
      `Error in FeeScheduleTemplateAPIService.${method}: ${error instanceof Error ? error.message : String(error)}`
    );
    this.method = method;
    this.error = error;
  }
}
